import React from "react";
import {Link, IndexLink} from "react-router";
import styles from "./header.scss";

import BaseComponent from "../baseComponent.js";
import InternalEvent from "../../core/constants/internalEvent.js";
import IdentityAccessService from "../../core/services/identityAccessService.js";

const smashIcon = require("file!../../img/smash-icon.png");
const animations = require("create-keyframe-animation");

class Links extends BaseComponent {
  logout() {
    this.publish(InternalEvent.App.SHOW_APP_MODAL, {
      onAgree: () => {
        document.location.href = "/";
      },
      header: "Do you really want to logout?"
    });
  }

  render() {
    var links = [];
    if (isMobile()) {
      links.push(<IndexLink to={"/"} className={styles.link} activeClassName={styles.linkActivated} key="1">
        <div>Databank</div>
      </IndexLink>);
      links.push(<Link to={"/dashboard"} className={styles.link} activeClassName={styles.linkActivated} key="2">
        <div>Dashboard</div>
      </Link>);
      links.push(<Link onClick={this.logout} className={styles.link} activeClassName={styles.linkActivated} key="3">
        <div>Logout</div>
      </Link>);
    } else {
      links.push(<IndexLink to={"/"} className={styles.link} activeClassName={styles.linkActivated} key="1">
        <div>Databank</div>
      </IndexLink>);
      links.push(<Link to={"/dashboard"} className={styles.link} activeClassName={styles.linkActivated} key="2">
        <div>Dashboard</div>
      </Link>);
      if (window.smash.env.host.indexOf("app.smash.bi") === -1) {
        links.push(<Link to={"/analyticsStudio"} className={styles.link} activeClassName={styles.linkActivated}
                         key="3">
          <div>Analytic Studio</div>
        </Link>);
      }
      links.push(<Link to={"/profile"} className={styles.link} activeClassName={styles.linkActivated} key="4">
        <div>Profile</div>
      </Link>);
      links.push(<Link onClick={this.logout} className={styles.link} activeClassName={styles.linkActivated} key="5">
        <div>Logout</div>
      </Link>);
    }
    return (
      <div className={styles.links}>
        {links}
      </div>
    )
  }
}

export default class Header extends BaseComponent {
  constructor(props) {
    super(props);
    this.subscribeEvents();
  }

  componentDidMount() {
    this.registerHeaderAnimation();

    $("#LogoutPopUp").click(function (event) {
      $("#user-profile-modal").openModal({
          dismissible: true,
          opacity: 0.0,
          in_duration: 300,
          out_duration: 200,
          starting_top: '1%',
          ending_top: '70px'
        }
      );
      event.preventDefault();
    });


    $(window).on("resize", () => {
      if (window.isMobile()) {
        if ($(window).width() < 600 || $(window).height() < 600) {
          $(this.refs.navbarToggle).css("opacity", 1);
          this.hideHeader();
        } else if ($(this.refs.navbar).position().top < 0) {
          this.showHeader();
        }
      }
    });

    if (window.isMobile()) {
      this.hideHeader();
      $(".navbar__links").find("a").on("click", function () {
        this.hideHeader();
      });
    }
  }

  componentWillUnmount() {
    super.unsubscribeAll();
  }

  registerHeaderAnimation() {
    let options = {
      duration: 300,
      easing: 'ease-in-out'
    };

    animations.registerAnimation({
      name: "showNavbar",
      animation: [{translate: [0, -55]}, {translate: [0, 0]}],
      presets: options
    });

    animations.registerAnimation({
      name: "hideNavbar",
      animation: [{translate: [0, 0]}, {translate: [0, -55]}],
      presets: options
    });
  }

  subscribeEvents() {
    this.subscribe(InternalEvent.App.SHOW_NAVBAR, this.showHeader);
    this.subscribe(InternalEvent.App.HIDE_NAVBAR, this.hideHeader);
  }

  showHeader() {
    animations.runAnimation(this.refs.navbar, "showNavbar");
  }

  hideHeader() {
    animations.runAnimation(this.refs.navbar, "hideNavbar");
  }

  onNavigateBtnClick(e) {
    this.hideHeader();
  }

  onUserBtnClick() {
    var menu = $("#admin-menu");
    if (IdentityAccessService.isUserLoggedin()) {
      if (menu.hasClass("active")) {
        menu.removeClass("active").slideUp();
      } else {
        menu.addClass("active").slideDown();
      }
    }
  }


  render() {
    const isMobile = window.isMobile();
    return (
      <div id="app-bar" className={isMobile ? styles.navbarMobile : styles.navbar} ref="navbar">
        <div className={styles.logo}>
          <img src={smashIcon}/>
        </div>
        <div className={isMobile ? styles.titleMobile : styles.title}>SMASH.BI</div>
        <div style={{flex: 1}}></div>
        <Links/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.jsx